

<div class="links">
    {{content}}
    <a *ngIf="!isContentToggled && original?.length > limit" (click)="toggleContent()" style="color:blue; text-decoration: underline;">read more</a>  
    <a *ngIf="isContentToggled && original?.length > limit" (click)="toggleContent()" style="color:blue; text-decoration: underline;">read less</a>
</div>
